/**
 * Partner workspace route for a trip; group (master) trips have their own page.
 * @param {{ id: number|string, is_master_trip?: boolean|number }} trip
 * @returns {string|null}
 */
export const getPartnerTripPath = (trip) => {
  if (!trip?.id) return null;
  return trip.is_master_trip ? `/partner/master-trips/${trip.id}` : `/partner/trips/${trip.id}`;
};

export default getPartnerTripPath;
